export function getOSKeyLabel(modifier: string): string {
  const platform = navigator.platform.toLowerCase();
  const isMac = platform.includes('mac');
  const isWindows = platform.includes('win');
  const isLinux = platform.includes('linux');

  if (modifier === 'control') {
    return isMac ? '⌘' : 'Ctrl';
  }

  if (modifier === 'alt') {
    return isMac ? '⌥' : 'Alt';
  }

  if (modifier === 'shift') {
    return 'Shift';
  }

  if (modifier === 'meta') {
    return isMac ? '⌘' : 'Meta';
  }

  return modifier;
}
